import React from 'react';

const ToolbarSeparator = () => (
  <div className="tw-bg-zinc-200 tw-h-full tw-min-h-[1.5rem] tw-w-[1px] tw-mx-1" />
);

export default ToolbarSeparator;
